import { ErrorBoundary } from "@error-tracking/client";
import React, { useCallback } from "react";

interface ErrorFallbackProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

function ErrorFallback({ children, fallback = null }: ErrorFallbackProps) {
  const renderFallback = useCallback(() => fallback, [fallback]);
  return <ErrorBoundary fallback={renderFallback}>{children}</ErrorBoundary>;
}

export { ErrorFallback };
export type { ErrorFallbackProps };
